// import React, { useEffect, useState } from "react";
// import api from "../../../api/axios";
// import Select from "react-select";
// import Swal from "sweetalert2";
// import html2pdf from "html2pdf.js";

// export default function PayrollRun() {
//   const [runs, setRuns] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [usingSample, setUsingSample] = useState(false);

//   const [employees, setEmployees] = useState([]);
//   const [selectedEmployees, setSelectedEmployees] = useState([]);

//   const [showRunForm, setShowRunForm] = useState(false);
//   const [buttonLoading, setButtonLoading] = useState(false);

//   const [showPayslipModal, setShowPayslipModal] = useState(false);
//   const [payslipItems, setPayslipItems] = useState([]);
//   const [selectedPayslip, setSelectedPayslip] = useState(null);

//   const [payslipLoading, setPayslipLoading] = useState(null);

//   const [form, setForm] = useState({
//     period: "",
//   });

//   useEffect(() => {
//     loadRuns();
//     loadEmployees();
//   }, []);

//   const formatDate = (date) => {
//     if (!date) return "";
//     try {
//       return String(date).split("T")[0];
//     } catch {
//       return String(date);
//     }
//   };

//   const formatCurrency = (value) => {
//     const n = Number(value || 0);
//     return new Intl.NumberFormat("en-IN", {
//       style: "currency",
//       currency: "INR",
//       maximumFractionDigits: 2,
//       minimumFractionDigits: 2,
//     }).format(Number(n.toFixed(2)));
//   };

//   /* ===========================================================
//      LOAD EMPLOYEES
//   =========================================================== */
//   const loadEmployees = async () => {
//     try {
//       const res = await api.get("hrms/employees");

//       const options = res.data.data.map((emp) => ({
//         value: emp.id,
//         label: `${emp.first_name} ${emp.last_name} (${emp.employee_code})`,
//       }));

//       setEmployees(options);
//     } catch (err) {
//       console.warn("Employee API failed → sample employees", err);
//       setEmployees([
//         { value: 1, label: "John Doe (EMP001)" },
//         { value: 2, label: "Priya S (EMP002)" },
//         { value: 3, label: "Ramesh Kumar (EMP003)" },
//       ]);
//     }
//   };

//   /* ===========================================================
//      LOAD PAYROLL RUNS
//   =========================================================== */
//   const loadRuns = async () => {
//     setLoading(true);

//     try {
//       const res = await api.get("hrms/prms/runs");
//       const data = res?.data?.data?.data ?? res?.data?.data;

//       setRuns(Array.isArray(data) ? data : []);
//       setUsingSample(false);
//     } catch (err) {
//       console.warn("Sample Payroll Runs Loaded", err);

//       setRuns([
//         {
//           id: 1,
//           period: "2025-11",
//           created_at: "2025-11-30T00:00:00.000000Z",
//           run_date: "2025-11-30",
//           status: "completed",
//           items_count: 1,
//           total_cost: 178000,
//         },
//       ]);
//       setUsingSample(true);
//     }

//     setLoading(false);
//   };

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   /* ===========================================================
//      START PAYROLL RUN
//   =========================================================== */
//   const startRun = async () => {
//     if (!form.period) {
//       Swal.fire(
//         "Missing Fields",
//         "Period and Run Date are required.",
//         "warning"
//       );
//       return;
//     }
//     const today = new Date().toISOString().split("T")[0];

//     const payload = {
//       period: form.period,
//       run_date: today,
//       employee_ids: selectedEmployees.map((e) => e.value),
//       meta: {},
//     };

//     setButtonLoading(true);

//     try {
//       await api.post("hrms/prms/runs", payload);
//       Swal.fire("Success!", "Payroll run completed.", "success");
//       setForm({
//         period: "",
//       });
//       setSelectedEmployees([]);
//       setShowRunForm(false);
//       loadRuns();
//     } catch (err) {
//       Swal.fire("Sample Mode", "Payroll run stored locally.", "info");

//       const newRun = {
//         id: runs.length + 1,
//         period: form.period,
//         created_at: new Date().toISOString(),
//         run_date: today,
//         status: "completed",
//         total_cost: 0,
//         items_count: selectedEmployees.length,
//       };

//       setRuns((prev) => [...prev, newRun]);
//       setShowRunForm(false);
//     }

//     setButtonLoading(false);
//   };

//   /* ===========================================================
//      OPEN PAYSLIPS FOR RUN
//   =========================================================== */
//   const openPayslip = async (runId) => {
//     setPayslipLoading(runId);

//     try {
//       const res = await api.get(`hrms/prms/runs/${runId}`);
//       const data = res?.data?.data;

//       const runPeriod = data?.period ?? "";
//       const items = data?.items ?? [];

//       // Inject period inside each payslip item
//       const withPeriod = items.map((it) => ({
//         ...it,
//         period: runPeriod,
//       }));

//       setPayslipItems(withPeriod);
//       setSelectedPayslip(withPeriod[0] ?? null);
//       setShowPayslipModal(true);
//     } catch (err) {
//       Swal.fire("Error", "Payslips not available", "error");
//     }

//     setPayslipLoading(null);
//   };

//   /* ===========================================================
//      DOWNLOAD PAYSLIP PDF
//   =========================================================== */
//   const downloadPDF = () => {
//     const element = document.getElementById("payslip-content");

//     const opt = {
//       margin: [0.5, 0.5],
//       filename: `payslip_${selectedPayslip.employee.employee_code}.pdf`,
//       image: { type: "jpeg", quality: 1 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
//     };

//     html2pdf().set(opt).from(element).save();
//   };

//   if (loading) {
//     return <div className="text-center fw-bold p-5">Loading...</div>;
//   }

//   return (
//     <div style={{ background: "#eef6fd", minHeight: "100vh" }}>
//       <div className="container py-4">
//         {/* HEADER */}
//         <div className="d-flex justify-content-between mb-4">
//           <h3 className="fw-bold">Payroll Run</h3>

//           <button
//             className="btn btn-primary"
//             onClick={() => setShowRunForm(true)}
//           >
//             <i className="bi bi-plus-circle me-2"></i> Start New Run
//           </button>
//         </div>

//         {usingSample && (
//           <span className="badge bg-warning text-dark mb-3">
//             Using Sample Data
//           </span>
//         )}

//         {/* ===========================================================
//            START RUN FORM
//         =========================================================== */}
//         {showRunForm && (
//           <div className="bg-white border rounded shadow-sm p-4 mb-4">
//             <h5 className="fw-bold mb-3">Start Payroll Run</h5>

//             <div className="row g-3">
//               <div className="col-md-6">
//                 <label className="form-label">Period (YYYY-MM)</label>
//                 <input
//                   type="month"
//                   name="period"
//                   className="form-control"
//                   value={form.period}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="col-md-12">
//                 <label className="form-label">Select Employees</label>
//                 <Select
//                   isMulti
//                   options={employees}
//                   value={selectedEmployees}
//                   onChange={setSelectedEmployees}
//                   placeholder="Search employees..."
//                 />
//               </div>
//             </div>

//             <div className="d-flex justify-content-end gap-2 mt-4">
//               <button
//                 className="btn btn-secondary"
//                 onClick={() => setShowRunForm(false)}
//               >
//                 Cancel
//               </button>

//               <button
//                 className="btn btn-primary"
//                 onClick={startRun}
//                 disabled={buttonLoading}
//               >
//                 {buttonLoading ? "Processing..." : "Start Run"}
//               </button>
//             </div>
//           </div>
//         )}

//         {/* ===========================================================
//            PAYROLL HISTORY
//         =========================================================== */}
//         <div className="bg-white border rounded shadow-sm p-4">
//           <h5 className="fw-bold mb-3">Payroll History</h5>

//           <div className="table-responsive">
//             <table className="table align-middle">
//               <thead>
//                 <tr>
//                   <th>Period</th>
//                   <th>Run Date</th>
//                   <th>Status</th>
//                   <th>Employees</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {runs.map((run) => (
//                   <tr key={run.id}>
//                     <td>{run.period}</td>
//                     <td>{formatDate(run.created_at ?? run.run_date)}</td>
//                     <td>
//                       <StatusBadge status={run.status} />
//                     </td>
//                     <td>{run.items_count ?? run.employees}</td>
//                     <td>
//                       <button
//                         className="btn btn-sm btn-outline-primary"
//                         onClick={() => openPayslip(run.id)}
//                         disabled={payslipLoading === run.id}
//                       >
//                         {payslipLoading === run.id ? "Loading…" : "Payslips"}
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* ===========================================================
//             PAYSLIP MODAL
//         =========================================================== */}
//         {showPayslipModal && (
//           <div className="modal d-block" style={{ background: "#00000066" }}>
//             <div className="modal-dialog modal-xl modal-dialog-centered">
//               <div className="modal-content">
//                 <div className="modal-header">
//                   <h5 className="modal-title">Payslips</h5>
//                   <button
//                     className="btn-close"
//                     onClick={() => setShowPayslipModal(false)}
//                   ></button>
//                 </div>

//                 <div className="modal-body row">
//                   {/* LEFT SIDE EMPLOYEE LIST */}
//                   <div
//                     className="col-4 border-end"
//                     style={{ maxHeight: "70vh", overflowY: "auto" }}
//                   >
//                     <h6 className="fw-bold mb-3">Employees in this run</h6>

//                     {payslipItems.map((item) => (
//                       <button
//                         key={item.employee_id}
//                         className={`btn w-100 mb-2 text-start ${
//                           selectedPayslip?.employee_id === item.employee_id
//                             ? "btn-primary text-white"
//                             : "btn-light"
//                         }`}
//                         onClick={() => setSelectedPayslip(item)}
//                       >
//                         {item.employee.first_name} {item.employee.last_name}
//                         <br />
//                         <small className="text-muted">
//                           {item.employee.employee_code}
//                         </small>
//                       </button>
//                     ))}
//                   </div>

//                   {/* RIGHT SIDE PAYSLIP PREVIEW */}
//                   <div
//                     className="col-8"
//                     style={{ maxHeight: "70vh", overflowY: "auto" }}
//                   >
//                     {selectedPayslip ? (
//                       <>
//                         <div
//                           id="payslip-preview"
//                           className="p-3 border rounded bg-white"
//                         >
//                           <Payslip
//                             item={selectedPayslip}
//                             formatCurrency={formatCurrency}
//                           />
//                         </div>

//                         <button
//                           className="btn btn-primary mt-3"
//                           onClick={downloadPDF}
//                         >
//                           Download PDF
//                         </button>
//                       </>
//                     ) : (
//                       <p>Select an employee to view payslip</p>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// /* ===========================================================
//    PAYSLIP TEMPLATE (NOW ALWAYS USES run.period)
// =========================================================== */
// function Payslip({ item }) {
//   const emp = item?.employee ?? {};
//   const meta = item?.meta ?? {};
//   const attendance = meta.attendance ?? {};

//   const earnings = meta.components?.filter((c) => c.type === "earning") ?? [];
//   const deductions =
//     meta.components?.filter((c) => c.type === "deduction") ?? [];

//   const reimbursements = meta.reimbursements ?? [];
//   const loans = meta.loans ?? [];

//   const fmt = (v) =>
//     `₹${Number(v || 0).toLocaleString("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     })}`;

//   // PERIOD (Month + Year)
//   const rawPeriod = item?.period ?? "";
//   let monthName = "";
//   let year = "";
//   if (rawPeriod.includes("-")) {
//     const [y, m] = rawPeriod.split("-");
//     year = y;
//     monthName = new Date(`${rawPeriod}-01`).toLocaleString("en-US", {
//       month: "long",
//     });
//   }

//   return (
//     <div
//       id="payslip-content"
//       style={{
//         fontFamily: "Inter, sans-serif",
//         color: "#333",
//         padding: "20px 40px",
//         background: "#fff",
//         width: "100%",
//       }}
//     >
//       {/* HEADER */}
//       <div style={{ textAlign: "center", marginBottom: "20px" }}>
//         <h2 style={{ fontWeight: 700, marginBottom: "5px" }}>Payslip</h2>
//         <p style={{ color: "#666" }}>
//           Salary for {monthName} {year}
//         </p>
//       </div>

//       <hr />

//       {/* EMPLOYEE DETAILS */}
//       <h4 style={{ fontWeight: 600, marginTop: "20px" }}>Employee Details</h4>
//       <table style={{ width: "100%", lineHeight: "1.7" }}>
//         <tbody>
//           <tr>
//             <td>
//               <b>Name:</b>
//             </td>
//             <td>
//               {emp.first_name} {emp.last_name}
//             </td>
//           </tr>
//           <tr>
//             <td>
//               <b>Employee Code:</b>
//             </td>
//             <td>{emp.employee_code}</td>
//           </tr>
//           <tr>
//             <td>
//               <b>Department:</b>
//             </td>
//             <td>{emp.department}</td>
//           </tr>
//           <tr>
//             <td>
//               <b>Designation:</b>
//             </td>
//             <td>{emp.designation}</td>
//           </tr>
//           <tr>
//             <td>
//               <b>Date of Joining:</b>
//             </td>
//             <td>{emp.date_of_joining?.split("T")[0]}</td>
//           </tr>
//         </tbody>
//       </table>

//       <hr style={{ marginTop: "20px" }} />

//       {/* ATTENDANCE */}
//       <h4 style={{ fontWeight: 600, marginTop: "15px" }}>Attendance Summary</h4>
//       <table style={{ width: "70%", lineHeight: "1.8" }}>
//         <tbody>
//           <tr>
//             <td>Working Days</td>
//             <td className="text-end">{attendance.working_days}</td>
//           </tr>
//           <tr>
//             <td>Present</td>
//             <td className="text-end">{attendance.present}</td>
//           </tr>
//           <tr>
//             <td>Leave</td>
//             <td className="text-end">{attendance.leave}</td>
//           </tr>
//           <tr>
//             <td>Absent</td>
//             <td className="text-end">{attendance.absent}</td>
//           </tr>
//           <tr style={{ fontWeight: 600 }}>
//             <td>Loss of Pay</td>
//             <td className="text-end">{fmt(meta.lop_amount)}</td>
//           </tr>
//         </tbody>
//       </table>

//       <hr style={{ marginTop: "20px" }} />

//       {/* SALARY BREAKUP */}
//       <div style={{ display: "flex", gap: "40px", marginTop: "20px" }}>
//         {/* Earnings */}
//         <div style={{ flex: 1 }}>
//           <h4 style={{ fontWeight: 600 }}>Earnings</h4>
//           <table style={{ width: "100%" }}>
//             <tbody>
//               {earnings.map((e, i) => (
//                 <tr key={i}>
//                   <td>{e.component}</td>
//                   <td style={{ textAlign: "right" }}>{fmt(e.amount)}</td>
//                 </tr>
//               ))}
//               <tr style={{ fontWeight: 700 }}>
//                 <td>Gross Salary</td>
//                 <td style={{ textAlign: "right" }}>{fmt(item.gross)}</td>
//               </tr>
//             </tbody>
//           </table>
//         </div>

//         {/* Deductions */}
//         <div style={{ flex: 1 }}>
//           <h4 style={{ fontWeight: 600 }}>Deductions</h4>
//           <table style={{ width: "100%" }}>
//             <tbody>
//               {deductions.map((d, i) => (
//                 <tr key={i}>
//                   <td>{d.component}</td>
//                   <td style={{ textAlign: "right" }}>{fmt(d.amount)}</td>
//                 </tr>
//               ))}
//               <tr style={{ fontWeight: 700 }}>
//                 <td>Total Deductions</td>
//                 <td style={{ textAlign: "right" }}>{fmt(item.deductions)}</td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <hr style={{ marginTop: "20px" }} />

//       {/* REIMBURSEMENTS */}
//       <h4 style={{ fontWeight: 600, marginTop: "25px" }}>Reimbursements</h4>

//       {reimbursements.length > 0 ? (
//         <table
//           style={{
//             width: "100%",
//             borderCollapse: "collapse",
//             marginTop: "10px",
//           }}
//         >
//           <thead>
//             <tr style={{ background: "#f7f7f7" }}>
//               <th style={{ padding: "8px", textAlign: "left" }}>Description</th>
//               <th style={{ padding: "8px", textAlign: "right" }}>Amount</th>
//             </tr>
//           </thead>

//           <tbody>
//             {reimbursements.map((r, idx) => (
//               <tr key={idx}>
//                 <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
//                   {r.description}
//                 </td>
//                 <td
//                   style={{
//                     padding: "8px",
//                     textAlign: "right",
//                     borderBottom: "1px solid #eee",
//                   }}
//                 >
//                   {fmt(r.amount)}
//                 </td>
//               </tr>
//             ))}

//             <tr style={{ fontWeight: 700 }}>
//               <td style={{ padding: "10px" }}>Total Reimbursements</td>
//               <td style={{ padding: "10px", textAlign: "right" }}>
//                 {fmt(meta.reimbursement_total)}
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       ) : (
//         <p style={{ color: "#777" }}>No reimbursements</p>
//       )}

//       <hr style={{ marginTop: "20px" }} />

//       {/* LOANS */}
//       <h4 style={{ fontWeight: 600, marginTop: "25px" }}>Loan / EMI</h4>

//       {loans.length > 0 ? (
//         <table
//           style={{
//             width: "100%",
//             borderCollapse: "collapse",
//             marginTop: "10px",
//           }}
//         >
//           <thead>
//             <tr style={{ background: "#f7f7f7" }}>
//               <th style={{ padding: "8px", textAlign: "left" }}>Loan Name</th>
//               <th style={{ padding: "8px", textAlign: "right" }}>EMI Amount</th>
//             </tr>
//           </thead>

//           <tbody>
//             {loans.map((l, idx) => (
//               <tr key={idx}>
//                 <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
//                   {l.name}
//                 </td>
//                 <td
//                   style={{
//                     padding: "8px",
//                     textAlign: "right",
//                     borderBottom: "1px solid #eee",
//                   }}
//                 >
//                   {fmt(l.emi_deducted)}
//                 </td>
//               </tr>
//             ))}

//             <tr style={{ fontWeight: 700 }}>
//               <td style={{ padding: "10px" }}>Total EMI</td>
//               <td style={{ padding: "10px", textAlign: "right" }}>
//                 {fmt(meta.loan_total_emi)}
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       ) : (
//         <p style={{ color: "#777" }}>No loan deductions</p>
//       )}

//       <hr />

//       {/* NET PAY */}
//       <h2 style={{ fontWeight: 700, marginTop: "15px" }}>
//         Net Salary: {fmt(item.net)}
//       </h2>

//       <p
//         style={{
//           textAlign: "center",
//           fontSize: "12px",
//           color: "#777",
//           marginTop: "30px",
//         }}
//       >
//         This is a system-generated payslip. No signature is required.
//       </p>
//     </div>
//   );
// }

// /* ===========================================================
//    STATUS BADGE
// =========================================================== */
// function StatusBadge({ status }) {
//   if (status === "completed") {
//     return (
//       <span className="badge bg-success-subtle text-success">Completed</span>
//     );
//   }
//   return <span className="badge bg-warning-subtle text-warning">{status}</span>;
// }

import React, { useEffect, useState } from "react";
import api from "../../../api/axios";
import Select from "react-select";
import Swal from "sweetalert2";
import html2pdf from "html2pdf.js";

export default function PayrollRun() {
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [usingSample, setUsingSample] = useState(false);

  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  const [showRunForm, setShowRunForm] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const [showPayslipModal, setShowPayslipModal] = useState(false);
  const [payslipItems, setPayslipItems] = useState([]);
  const [selectedPayslip, setSelectedPayslip] = useState(null);

  const [payslipLoading, setPayslipLoading] = useState(null);

  const [form, setForm] = useState({ period: "" });

  useEffect(() => {
    loadRuns();
    loadEmployees();
  }, []);

  const formatDate = (date) => {
    if (!date) return "";
    return String(date).split("T")[0];
  };

  const formatCurrency = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    }).format(Number(value || 0));

  /* Load employees */
  const loadEmployees = async () => {
    try {
      const res = await api.get("hrms/employees");
      const options = res.data.data.map((emp) => ({
        value: emp.id,
        label: `${emp.first_name} ${emp.last_name} (${emp.employee_code})`,
      }));
      setEmployees(options);
    } catch (err) {
      console.warn("employee api failed", err);
      setEmployees([
        { value: 1, label: "John Doe (EMP001)" },
        { value: 2, label: "Priya S (EMP002)" },
      ]);
    }
  };

  /* Load runs */
  const loadRuns = async () => {
    setLoading(true);
    try {
      const res = await api.get("hrms/prms/runs");
      const list = res?.data?.data?.data ?? res?.data?.data ?? [];
      setRuns(list);
      setUsingSample(false);
    } catch (err) {
      console.warn("runs api failed", err);
      setRuns([
        {
          id: 1,
          period: "2025-11",
          created_at: "2025-11-30T00:00:00Z",
          status: "completed",
          items_count: 1,
        },
      ]);
      setUsingSample(true);
    }
    setLoading(false);
  };

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  /* Start run: run_date auto-filled today */
  const startRun = async () => {
    if (!form.period) {
      Swal.fire("Missing Fields", "Please select period", "warning");
      return;
    }

    const payload = {
      period: form.period,
      run_date: new Date().toISOString().split("T")[0],
      employee_ids: selectedEmployees.map((e) => e.value),
      meta: {},
    };

    setButtonLoading(true);
    try {
      await api.post("hrms/prms/runs", payload);
      Swal.fire("Success", "Payroll run completed", "success");
      setForm({ period: "" });
      setSelectedEmployees([]);
      setShowRunForm(false);
      loadRuns();
    } catch (err) {
      console.warn("api failed, sample mode", err);
      Swal.fire("Sample Mode", "Payroll run stored locally", "info");
      const newRun = {
        id: runs.length + 1,
        period: form.period,
        created_at: new Date().toISOString(),
        status: "completed",
        items_count: selectedEmployees.length,
      };
      setRuns((prev) => [...prev, newRun]);
      setForm({ period: "" });
      setSelectedEmployees([]);
      setShowRunForm(false);
    }
    setButtonLoading(false);
  };

  /* Open payslip modal: fetch run by id, inject period into items (consolidated will already be period) */
  const openPayslip = async (runId) => {
    setPayslipLoading(runId);
    try {
      const res = await api.get(`hrms/prms/runs/${runId}`);
      const run = res?.data?.data ?? res?.data;
      const runPeriod = run?.period ?? "";
      const items = run?.items ?? run?.data?.items ?? [];

      const withPeriod = items.map((it) => ({ ...it, period: runPeriod }));
      setPayslipItems(withPeriod);
      setSelectedPayslip(withPeriod[0] ?? null);
      setShowPayslipModal(true);
    } catch (err) {
      console.error("openPayslip failed", err);
      Swal.fire("Error", "Payslips not available", "error");
    }
    setPayslipLoading(null);
  };

  const downloadPDF = () => {
    if (!selectedPayslip) {
      Swal.fire("Select", "Select an employee", "warning");
      return;
    }
    const element = document.getElementById("payslip-content");
    const opt = {
      margin: 8,
      filename: `payslip_${selectedPayslip.employee.employee_code}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };
    html2pdf().set(opt).from(element).save();
  };

  if (loading) return <div className="text-center fw-bold p-5">Loading...</div>;

  return (
    <div style={{ background: "#eef6fd", minHeight: "100vh" }}>
      <div className="container py-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="fw-bold">Payroll Run</h3>
          <button
            className="btn btn-primary"
            onClick={() => setShowRunForm(true)}
          >
            <i className="bi bi-plus-circle me-2"></i> Start New Run
          </button>
        </div>

        {usingSample && (
          <span className="badge bg-warning text-dark mb-3">
            Using Sample Data
          </span>
        )}

        {/* Add Run Form */}
        {showRunForm && (
          <div className="bg-white border rounded shadow-sm p-4 mb-4">
            <h5 className="fw-bold mb-3">Start Payroll Run</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Period (YYYY-MM)</label>
                <input
                  type="month"
                  name="period"
                  className="form-control"
                  value={form.period}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-12">
                <label className="form-label">Select Employees</label>
                <Select
                  isMulti
                  options={employees}
                  value={selectedEmployees}
                  onChange={setSelectedEmployees}
                  placeholder="Search employees..."
                />
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-4">
              <button
                className="btn btn-secondary"
                onClick={() => setShowRunForm(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={startRun}
                disabled={buttonLoading}
              >
                {buttonLoading ? "Processing..." : "Start Run"}
              </button>
            </div>
          </div>
        )}

        {/* Runs Table */}
        <div className="bg-white border rounded shadow-sm p-4 mb-3">
          <h5 className="fw-bold mb-3">Payroll History</h5>
          <div className="table-responsive">
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>Period</th>
                  <th>Run Date</th>
                  <th>Status</th>
                  <th>Employees</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {runs.map((run) => (
                  <tr key={run.id}>
                    <td>{run.period}</td>
                    <td>{formatDate(run.created_at ?? run.run_date)}</td>
                    <td>
                      <StatusBadge status={run.status} />
                    </td>
                    <td>{run.items_count ?? run.employees ?? 0}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => openPayslip(run.id)}
                        disabled={payslipLoading === run.id}
                      >
                        {payslipLoading === run.id ? "Loading..." : "Payslips"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Payslip Modal */}
        {showPayslipModal && (
          <div className="modal d-block" style={{ background: "#00000066" }}>
            <div className="modal-dialog modal-xl modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Payslips</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowPayslipModal(false)}
                  ></button>
                </div>

                <div className="modal-body row">
                  <div
                    className="col-4 border-end"
                    style={{ maxHeight: "70vh", overflowY: "auto" }}
                  >
                    <h6 className="fw-bold mb-3">Employees in this run</h6>
                    {payslipItems.length === 0 && (
                      <p className="text-muted">No employees</p>
                    )}
                    {payslipItems.map((item) => (
                      <button
                        key={item.employee_id}
                        className={`btn w-100 mb-2 text-start ${
                          selectedPayslip?.employee_id === item.employee_id
                            ? "btn-primary text-white"
                            : "btn-light"
                        }`}
                        onClick={() => setSelectedPayslip(item)}
                      >
                        {item.employee?.first_name} {item.employee?.last_name}
                        <br />
                        <small className="text-muted">
                          {item.employee?.employee_code}
                        </small>
                      </button>
                    ))}
                  </div>

                  <div
                    className="col-8"
                    style={{ maxHeight: "70vh", overflowY: "auto" }}
                  >
                    {selectedPayslip ? (
                      <>
                        <div
                          id="payslip-content"
                          className="p-3 border rounded bg-white"
                        >
                          <Payslip
                            item={selectedPayslip}
                            formatCurrency={formatCurrency}
                          />
                        </div>

                        <div className="d-flex gap-2 mt-3">
                          <button
                            className="btn btn-outline-primary"
                            onClick={() => window.print()}
                          >
                            Print
                          </button>
                          <button
                            className="btn btn-primary"
                            onClick={downloadPDF}
                          >
                            Download PDF
                          </button>
                        </div>
                      </>
                    ) : (
                      <p>Select an employee to view payslip</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* Payslip component (clean, white-card style — Option A) */
function Payslip({ item, formatCurrency }) {
  const emp = item?.employee ?? {};
  const meta = item?.meta ?? {};
  const components = meta.components ?? [];
  const earnings = components.filter((c) => c.type === "earning");
  const deductions = components.filter((c) => c.type === "deduction");
  const reimbursements = meta.reimbursements ?? [];
  const loans = meta.loans ?? [];

  const rawPeriod = item?.period ?? "";
  let monthName = "";
  let year = "";
  if (typeof rawPeriod === "string" && rawPeriod.includes("-")) {
    const [y, m] = rawPeriod.split("-");
    year = y;
    try {
      monthName = new Date(`${rawPeriod}-01`).toLocaleString("en-US", {
        month: "long",
      });
    } catch {
      monthName = rawPeriod;
    }
  } else {
    monthName = rawPeriod;
  }

  const fmt = formatCurrency ?? ((v) => `₹${Number(v || 0).toFixed(2)}`);

  return (
    <div style={{ fontFamily: "Inter, sans-serif", color: "#222" }}>
      {/* Header */}
      <div className="text-center mb-3">
        <h3 className="fw-bold m-0">Payslip</h3>
        <p className="text-muted m-0">
          Salary for {monthName} {year}
        </p>
        <hr />
      </div>

      {/* Employee details */}
      <div className="mb-3">
        <h6 className="fw-semibold">Employee Details</h6>
        <div className="row">
          <div className="col-6">
            <p className="m-0">
              <strong>
                {emp.first_name} {emp.last_name}
              </strong>
            </p>
            <p className="m-0 text-muted">Code: {emp.employee_code}</p>
            <p className="m-0 text-muted">CTC: {fmt(emp.ctc_amount)}</p>
          </div>
          <div className="col-6 text-end">
            <p className="m-0 text-muted">{emp.department}</p>
            <p className="m-0 text-muted">{emp.designation}</p>
            <p className="m-0 text-muted">
              DOJ: {emp.date_of_joining?.split("T")[0]}
            </p>
          </div>
        </div>
      </div>

      <hr />

      {/* Attendance */}
      {meta.attendance && (
        <>
          <h6 className="fw-semibold">Attendance</h6>
          <table className="table table-sm w-50 mb-3">
            <tbody>
              <tr>
                <td>Working Days</td>
                <td className="text-end">{meta.attendance.working_days}</td>
              </tr>
              <tr>
                <td>Present</td>
                <td className="text-end">{meta.attendance.present}</td>
              </tr>
              <tr>
                <td>Leave</td>
                <td className="text-end">{meta.attendance.leave}</td>
              </tr>
              <tr>
                <td>Absent</td>
                <td className="text-end">{meta.attendance.absent}</td>
              </tr>
              <tr className="fw-bold">
                <td>LOP Amount</td>
                <td className="text-end">{fmt(meta.lop_amount)}</td>
              </tr>
            </tbody>
          </table>
        </>
      )}

      {/* Earnings & Deductions */}
      <div className="row">
        <div className="col-6">
          <h6 className="fw-semibold">Earnings</h6>
          <table className="table table-sm">
            <tbody>
              {earnings.map((c, i) => (
                <tr key={i}>
                  <td>{c.component}</td>
                  <td className="text-end">{fmt(c.amount)}</td>
                </tr>
              ))}
              <tr className="fw-bold">
                <td>Gross</td>
                <td className="text-end">{fmt(item.gross)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="col-6">
          <h6 className="fw-semibold">Deductions</h6>
          <table className="table table-sm">
            <tbody>
              {deductions.map((c, i) => (
                <tr key={i}>
                  <td>{c.component}</td>
                  <td className="text-end">{fmt(c.amount)}</td>
                </tr>
              ))}
              <tr className="fw-bold">
                <td>Total Deductions</td>
                <td className="text-end">{fmt(item.deductions)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Reimbursements */}
      <div className="mt-3">
        <h6 className="fw-semibold">Reimbursements</h6>
        {reimbursements.length > 0 ? (
          <table className="table table-sm">
            <tbody>
              {reimbursements.map((r, i) => (
                <tr key={i}>
                  <td>{r.name}</td>
                  <td className="text-end">{fmt(r.amount)}</td>
                </tr>
              ))}
              <tr className="fw-bold">
                <td>Total</td>
                <td className="text-end">{fmt(meta.reimbursement_total)}</td>
              </tr>
            </tbody>
          </table>
        ) : (
          <p className="text-muted">No reimbursements</p>
        )}
      </div>

      {/* Loans */}
      <div className="mt-3">
        <h6 className="fw-semibold">Loan / EMI</h6>
        {loans.length > 0 ? (
          <table className="table table-sm">
            <tbody>
              {loans.map((l, i) => (
                <tr key={i}>
                  <td>{l.name}</td>
                  <td className="text-end">{fmt(l.emi)}</td>
                </tr>
              ))}
              <tr className="fw-bold">
                <td>Total EMI</td>
                <td className="text-end">{fmt(meta.loan_total_emi)}</td>
              </tr>
            </tbody>
          </table>
        ) : (
          <p className="text-muted">No loan deductions</p>
        )}
      </div>

      <hr />
      <div className="text-end">
        <h5 className="fw-bold">Net Salary: {fmt(item.net)}</h5>
      </div>

      <p className="text-center text-muted mt-3">
        This is a computer-generated payslip.
      </p>
    </div>
  );
}

function StatusBadge({ status }) {
  if (!status)
    return <span className="badge bg-warning-subtle text-warning">Draft</span>;
  if (status === "completed")
    return (
      <span className="badge bg-success-subtle text-success">Completed</span>
    );
  return (
    <span className="badge bg-secondary-subtle text-secondary">{status}</span>
  );
}
